import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-InterSpousal',
    templateUrl: './InterSpousal.component.html',
    styleUrls: ['./InterSpousal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InterSpousalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
